import { useState } from 'react';
import { ProofTabs } from '../components/ProofTabs';
import { Seo } from '../components/Seo';
import { AhiNarratedShowcase } from '../cinematic/AhiNarratedShowcase';
import { EyeScene } from '../cinematic/EyeScene';
import { FounderOceanScene } from '../cinematic/FounderOceanScene';
import { HandsScene } from '../cinematic/HandsScene';
import { useScenarios } from '../cinematic/useScenarios';
import { SITE_URL } from '../lib/siteUrl';

const siteUrl = SITE_URL;
const homeSchema = {
  '@context': 'https://schema.org',
  '@graph': [
    { '@type': 'Organization', '@id': `${siteUrl}/#organization`, name: 'Acoord', url: siteUrl, logo: `${siteUrl}/favicon.svg`, description: 'Acoord builds the Agent Human Interface for governed collaboration between people and AI agents.' },
    { '@type': 'SoftwareApplication', '@id': `${siteUrl}/#ahi`, name: 'Acoord AHI — Agent Human Interface', applicationCategory: 'DeveloperApplication', applicationSubCategory: 'Enterprise Agentic Orchestration Platform', operatingSystem: ['Web', 'macOS', 'Windows'], description: 'One command surface to observe, approve, steer, connect, and audit agents across an organization.', featureList: ['Human approval checkpoints', 'Evidence-grounded workflows', 'Enterprise connectors', 'Durable decision records'], provider: { '@id': `${siteUrl}/#organization` }, offers: { '@type': 'Offer', url: `${siteUrl}/pricing`, priceCurrency: 'USD', availability: 'https://schema.org/PreOrder' }, url: siteUrl },
    { '@type': 'WebPage', '@id': `${siteUrl}/#homepage`, name: 'Acoord AHI — Agentic Operating System', url: `${siteUrl}/#homepage`, description: 'A compact five-part introduction to AHI, product proof, workflows, connectors, ROI, and human authority.', mainEntity: { '@id': `${siteUrl}/#ahi` }, hasPart: [
      { '@type': 'WebPageElement', name: 'Agentic Operating System introduction', url: `${siteUrl}/#ahi` },
      { '@type': 'WebPageElement', name: 'Eighteen-industry AHI product demo', url: `${siteUrl}/#ahi-live` },
      { '@type': 'WebPageElement', name: 'Operational proof: workflows, 49 connectors, and ROI', url: `${siteUrl}/#connectors` }
    ] }
  ]
};

export default function HomePage({ onJoin }) {
  const scenarios = useScenarios();
  const [industryId, setIndustryId] = useState('ai-data');

  const seeAhiLive = (event) => {
    event.preventDefault();
    window.history.replaceState(null, '', '#ahi-live');
    document.getElementById('ahi-live')?.scrollIntoView({ behavior: 'instant', block: 'start' });
  };

  return <div className="home-consolidated" data-testid="consolidated-homepage">
    <Seo title="Acoord AHI — Agentic Operating System for Enterprise AI" description="Acoord AHI compiles human intent into checkpointed, auditable agent workflows across retrieval (PostgreSQL pgvector + BM25 + RRF), tools (tenant-scoped MCP routes to 50+ systems), and sandboxed code execution. Every consequential step pauses at a human checkpoint with evidence, then persists as a replayable decision record." path="/" schema={homeSchema} />
    <div className="film compact-home-film" data-testid="cinematic-film">
      <HandsScene onJoin={onJoin} onSeeAhi={seeAhiLive} />
      <EyeScene />
    </div>
    <AhiNarratedShowcase compact scenarios={scenarios} activeId={industryId} onScenarioSelect={setIndustryId} />
    <ProofTabs />
    <FounderOceanScene onJoin={onJoin} />
  </div>;
}